export default [{
    path: '/providers',
    name: 'providers',
    component: () =>
        import ('@/views/pages/providers/ProvidersList.vue'),
    meta: {
        pageTitle: 'Providers',
        breadcrumb: [{
            text: 'Providers',
            active: true,
            to:'/providers'
        }, ],
        resource: 'provider',
        action: 'read',
    },
},
{
    path: '/providers/view/:id',
    name: 'providers-view',
    component: () =>
        import ('@/views/pages/providers/ProvidersView.vue'),
    meta: {
        pageTitle: 'View provider',
        breadcrumb: [
        {
            text: 'Providers',
            to: '/providers'
        },{
            text: 'View',
            active: true,
        },],
        resource: 'provider',
        action: 'read',
    },
},
{
    path: '/providers/edit/:id',
    name: 'providers-edit',
    component: () =>
        import ('@/views/pages/providers/ProvidersEdit.vue'),
    meta: {
        pageTitle: 'Edit provider',
        breadcrumb: [
        {
            text: 'Providers',
            to: '/providers',
        },
        {
            text: 'Edit',
            active: true,
        } ],
        resource: 'provider',
        action: 'read',
    },
},
{
    path: '/providers/add',
    name: 'providers-add',
    component: () =>
        import ('@/views/pages/providers/ProvidersAdd.vue'),
    meta: {
        pageTitle: 'Create provider',
        breadcrumb: [
        {
            text: 'Providers',
            to: '/providers',
        },
        {
            text: 'Add',
            active: true,
        }
        ],
        resource: 'provider',
        action: 'read',
    },
}
]
